import React from 'react';
import {CardHeader as CardHeaderStrap} from 'reactstrap';
const CardHeader = props => {
    return (
        <CardHeaderStrap className="d-flex justify-content-between align-items-center">
            {props.children}
        </CardHeaderStrap>
    )
};
export default CardHeader